// dependencies
import { Map } from "immutable";

// graphs
import generateTimeSeries from "./multilineTimeSeries";

const initializeGraphs = (container, graphs, onSelect) => {
	const { requestsPerMinute } = graphs;

	const requestBuckets = requestsPerMinute;

	const maxResponseTime = requestBuckets.map((item) => Map({ date: item.get("date"), value: item.get("max", 0) }));
	const meanResponseTime = requestBuckets.map((item) => Map({ date: item.get("date"), value: item.get("mean", 0) }));
	const uniqueUsers = requestBuckets.map((item) =>
		Map({ date: item.get("date"), value: item.get("uniqueUsersCount", 0) })
	);

	generateTimeSeries(
		container,
		[
			{ id: "requestsPerMinute", data: requestBuckets.toJS(), maxRound: 10, strokeDash: "0" },
			{ id: "maxResponseTime", data: maxResponseTime.toJS(), maxRound: 100, strokeDash: "0" },
			{ id: "meanResponseTime", data: meanResponseTime.toJS(), maxRound: 100, strokeDash: "0" },
			{ id: "uniqueUsersCount", data: uniqueUsers.toJS(), maxRound: 10, strokeDash: "0" },
		],
		onSelect
	);
};

export default initializeGraphs;
